import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import _ from "lodash";

export default function AffiliateSelector({
  affiliates,
  onChange,
  selectedLocal,
}) {
  const sortedAffiliates = _.sortBy(affiliates, (item) =>
    item.display_name.toLowerCase()
  );
  return (
    <Autocomplete
      data-testid="select-locals-dropdown"
      disablePortal
      options={sortedAffiliates}
      getOptionLabel={(option) => option.display_name || ""}
      sx={{ width: 300 }}
      renderInput={(params) => <TextField {...params} label="Select a local" />}
      onChange={onChange}
      value={selectedLocal}
    />
  );
}
